<template>
  <div class="p-4 eoc-medications-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-4"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <h3 class="mb-0 ml-3">Medications</h3>
      </div>
      <view-switch :options="viewOptions" v-model="currentView" />
      <b-button
        class="pl-3 pr-3 pt-1 pb-1 mr-2"
        variant="primary"
        size="sm"
        @click="addPredefinedProtocol"
        ><i class="fa fa-plus mr-2"></i>New Protocol</b-button
      >
    </div>
    <div class="px-2">
      <div
        class="scheduled-container"
        :style="{
          visibility: currentView == 'scheduled' ? 'visible' : 'hidden',
          height: currentView == 'scheduled' ? '' : '0',
          overflow: 'hidden'
        }"
      >
        <div class="mt-1 mb-0 w-100 d-flex flex-row justify-content-between">
          <div class="d-flex align-items-center">
            <div>
              <a
                class="hover-pointer"
                style="font-size: 14px"
                @click="showReportRequestsModal = true"
              >
                <i class="fa fa-download"></i>
                <span class="ml-2 text-primary" style="font-size: 14px"
                  >Export</span
                >
              </a>
            </div>
            <div
              class="border-left border-med-light-gray pl-1 ml-1 mr-1"
              style="width: 1px; height: 19px"
            ></div>
            <vue-toggles
              @click="toggleTransferMedsToMars()"
              :value="transferToMars"
              height="20"
              width="30"
              checkedBg="#34C759"
              uncheckedBg="#FF6161"
            />
            <small class="ml-2">Transfer Medications to MARS</small>
          </div>
          <div
            class="d-flex flex-row justify-content-end align-items-center mb-3"
          >
            <div>
              <b-button
                class="pl-3 pr-3 pt-1 pb-1 mr-2"
                variant="primary"
                size="sm"
                @click="addScheduledMedication"
                ><i class="fa fa-plus mr-2"></i>New</b-button
              >
              <b-button
                class="pl-3 pr-3 pt-1 pb-1 "
                variant="danger"
                size="sm"
                :disabled="scheduledMedicationsSelected.length == 0"
                @click="removeSelectedScheduledMedication"
                ><i class="fa fa-minus mr-2"></i>Remove</b-button
              >
            </div>
          </div>
        </div>
        <grid
          ref="grid"
          :groupFeature="false"
          :columns="scheduledColumns"
          :autoHeight="true"
          :data="scheduledItems"
          :columnLines="false"
          :searchFeature="true"
          :stripeFeature="false"
          :selectionMode="scheduledGridConfig.selectionMode"
          @selectionchange="scheduledListeners.selectionChange"
          @renderrows="hookDropdownButtons"
          @renderrow="hookDropdownButtons"
        ></grid>
      </div>
      <div
        class="prn-container"
        :style="{
          visibility: currentView == 'prn' ? 'visible' : 'hidden',
          height: currentView == 'prn' ? '' : '0',
          overflow: 'hidden'
        }"
      >
        <div
          class="d-flex flex-row justify-content-end align-items-center mb-3"
        >
          <b-button
            class="pl-3 pr-3 pt-1 pb-1 mr-2"
            variant="primary"
            size="sm"
            @click="addPrnMedication"
            ><i class="fa fa-plus mr-2"></i>New</b-button
          >
          <b-button
            class="pl-3 pr-3 pt-1 pb-1 "
            variant="danger"
            size="sm"
            :disabled="prnMedicationsSelected.length == 0"
            @click="removeSelectedPrnMedication"
            ><i class="fa fa-minus mr-2"></i>Remove</b-button
          >
        </div>
        <grid
          ref="grid"
          :groupFeature="false"
          :columns="prnColumns"
          :autoHeight="true"
          :data="prnItems"
          :columnLines="false"
          :searchFeature="true"
          :stripeFeature="false"
          :selectionMode="scheduledGridConfig.selectionMode"
          @selectionchange="prnMedicationsScheduledListeners.selectionChange"
          @renderrows="hookDropdownButtons"
          @renderrow="hookDropdownButtons"
        ></grid>
      </div>
    </div>
    <b-modal
      centered
      ref="form-scheduled-modal"
      :title="(formScheduledId ? 'Edit' : 'Add') + ' scheduled medication'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitScheduledMedication"
      no-close-on-backdrop
      size="md-lg"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="Medication"
            :state="formScheduledErrors.medication.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.medication.join(', ')"
          >
            <v-select
              placeholder="Search for medications"
              v-model="formScheduled.medication"
              @search="searchMedications"
              :options="medications"
              :class="medications.length == 0 ? 'picker-hide-options' : ''"
            >
              <template #open-indicator> <span></span> </template>
            </v-select>
          </b-form-group>
          <b-form-group
            label="Route"
            :state="formScheduledErrors.route.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.route.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="formScheduled.route"
              :options="medicationRoutes"
            ></v-select>
          </b-form-group>
          <b-row>
            <b-col>
              <b-form-group
                label="Dosage"
                :state="formScheduledErrors.dosage.length == 0 ? null : false"
                :invalid-feedback="formScheduledErrors.dosage.join(', ')"
              >
                <b-form-input
                  placeholder=""
                  v-model="formScheduled.dosage"
                  type="number"
                  trim
                  :state="formScheduledErrors.dosage.length == 0 ? null : false"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Unit of measurement"
                :state="
                  formScheduledErrors.measurementUnit.length == 0 ? null : false
                "
                :invalid-feedback="
                  formScheduledErrors.measurementUnit.join(', ')
                "
              >
                <v-select
                  class=""
                  placeholder=""
                  v-model="formScheduled.measurementUnit"
                  :options="measurements"
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group
            label="Start Date"
            :state="formScheduledErrors.startDate.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.startDate.join(', ')"
          >
            <date-time-picker
              v-model="formScheduled.startDate"
              :errors="formScheduledErrors.startDate"
              :max="formScheduled.endDate ? formScheduled.endDate : null"
            />
          </b-form-group>
          <b-form-checkbox v-model="formScheduled.untilDischarge">
            Until Discharge
          </b-form-checkbox>
          <b-form-group
            label="End Date"
            :state="formScheduledErrors.endDate.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.endDate.join(', ')"
            :disabled="formScheduled.untilDischarge"
          >
            <date-time-picker
              v-model="formScheduled.endDate"
              :errors="formScheduledErrors.endDate"
              :min="formScheduled.startDate ? formScheduled.startDate : null"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Frequency"
            :state="formScheduledErrors.frequencyId.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.frequencyId.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="scheduledFrequency"
              :options="frequencyOptions"
            ></v-select>
          </b-form-group>
          <b-form-group
            v-if="formScheduled.frequencyId == 'daysOfWeek'"
            label=""
            :state="formScheduledErrors.weekDays.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.weekDays.join(', ')"
          >
            <week-days-picker v-model="formScheduled.weekDays" />
          </b-form-group>
          <b-form-group
            v-if="formScheduled.frequencyId == 'daysInterval'"
            label="Days interval"
            :state="
              formScheduledErrors.daysIntervalId.length == 0 ? null : false
            "
            :invalid-feedback="formScheduledErrors.daysIntervalId.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="daysInterval"
              :options="daysIntervalOptions"
            ></v-select>
          </b-form-group>
          <b-form-group
            label="Times per day"
            :state="
              formScheduledErrors.timesPerDayId.length == 0 ? null : false
            "
            :invalid-feedback="formScheduledErrors.timesPerDayId.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="timesPerDay"
              :options="timesPerDayOptions"
            ></v-select>
          </b-form-group>
          <b-form-group
            label="Times"
            :state="formScheduledErrors.medication.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.medication.join(', ')"
          >
            <div
              class="times-container rounded border w-100 d-flex flex-wrap justify-content-start align-items-start p-2"
            >
              <div
                v-for="timeIndex in Object.keys(formScheduled.times)"
                :key="timeIndex"
                class="mr-2"
              >
                <b-form-select
                  :options="timeOptions"
                  :value="formScheduled.times[timeIndex]"
                  @input="newValue => setTime(timeIndex, newValue)"
                ></b-form-select>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Instructions">
            <b-form-input
              placeholder=""
              v-model="formScheduled.instructions"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      ref="form-prn-modal"
      :title="(formPrnId ? 'Edit' : 'Add') + ' PRN medication'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitPrnMedication"
      no-close-on-backdrop
      size="md-lg"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="Medication"
            :state="formPrnErrors.medication.length == 0 ? null : false"
            :invalid-feedback="formPrnErrors.medication.join(', ')"
          >
            <v-select
              placeholder="Search for medications"
              v-model="formPrn.medication"
              @search="searchMedications"
              :options="medications"
              :class="medications.length == 0 ? 'picker-hide-options' : ''"
            >
              <template #open-indicator> <span></span> </template>
            </v-select>
          </b-form-group>
          <b-form-group
            label="Route"
            :state="formPrnErrors.route.length == 0 ? null : false"
            :invalid-feedback="formPrnErrors.route.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="formPrn.route"
              :options="medicationRoutes"
            ></v-select>
          </b-form-group>
          <b-row>
            <b-col>
              <b-form-group
                label="Dosage"
                :state="formPrnErrors.dosage.length == 0 ? null : false"
                :invalid-feedback="formPrnErrors.dosage.join(', ')"
              >
                <b-form-input
                  placeholder=""
                  v-model="formPrn.dosage"
                  type="number"
                  trim
                  :state="formPrnErrors.dosage.length == 0 ? null : false"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Unit of measurement"
                :state="
                  formPrnErrors.measurementUnit.length == 0 ? null : false
                "
                :invalid-feedback="formPrnErrors.measurementUnit.join(', ')"
              >
                <v-select
                  class=""
                  placeholder=""
                  v-model="formPrn.measurementUnit"
                  :options="measurements"
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-form-group
            label="Start Date"
            :state="formPrnErrors.startDate.length == 0 ? null : false"
            :invalid-feedback="formPrnErrors.startDate.join(', ')"
          >
            <date-time-picker
              v-model="formPrn.startDate"
              :errors="formPrnErrors.startDate"
              :max="formPrn.endDate ? formPrn.endDate : null"
            />
          </b-form-group>
          <b-form-group
            label="End Date"
            :state="formPrnErrors.endDate.length == 0 ? null : false"
            :invalid-feedback="formPrnErrors.endDate.join(', ')"
          >
            <date-time-picker
              v-model="formPrn.endDate"
              :errors="formPrnErrors.endDate"
              :min="formPrn.startDate ? formPrn.startDate : null"
            />
          </b-form-group>
          <b-form-group label="Maximum dosage per day">
            <b-form-input
              placeholder=""
              v-model="formPrn.maximumDosage"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Instructions">
            <b-form-input
              placeholder=""
              v-model="formPrn.instructions"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      ref="form-predefined-protocol-modal"
      title="Add Predefined Protocol"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitPredefinedProtocol"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="Start Date"
            :state="
              formPredefinedProtocolErrors.startDate.length == 0 ? null : false
            "
            :invalid-feedback="
              formPredefinedProtocolErrors.startDate.join(', ')
            "
          >
            <date-time-picker
              v-model="formPredefinedProtocol.startDate"
              :errors="formPredefinedProtocolErrors.startDate"
            />
          </b-form-group>
          <b-form-group
            label="Predefined Protocol"
            :state="
              formPredefinedProtocolErrors.predefinedProtocol.length == 0
                ? null
                : false
            "
            :invalid-feedback="
              formPredefinedProtocolErrors.predefinedProtocol.join(', ')
            "
          >
            <v-select
              class=""
              placeholder=""
              v-model="formPredefinedProtocol.predefinedProtocol"
              :options="predefinedProtocols"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="ScheduledAndPrnMedications"
    />
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import medicationServer from "../../server/medication";
import scheduledMedicationServer from "../../server/scheduledMedication";
import { mapActions, mapGetters, mapState } from "vuex";
import DateTimePicker from "../controls/DateTimePicker.vue";
import {
  validateNumberLessEqualThan,
  validateRequired,
  validateNumberNotNegative
} from "../../helpers/validation";
import WeekDaysPicker from "../controls/WeekDaysPicker";
import {
  frequencies,
  daysIntervals,
  timesPerDayOptions,
  timeOptions
} from "../../config/medications";
import prnMedicationServer from "../../server/prnMedication";
import predefinedProtocolServer from "../../server/predefinedProtocol";
import ViewSwitch from "../controls/ViewSwitch.vue";
import { formatDateTimeMysql } from "../../helpers/date";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";

export default {
  name: "EocViewMedications",
  components: {
    Grid,
    DateTimePicker,
    WeekDaysPicker,
    ReportRequestIndex,
    ViewSwitch
  },
  props: ["eocId", "clientId", "showing", "transferToMarsValue"],
  data() {
    const self = this;
    return {
      medications: [],
      currentView: "scheduled",
      viewOptions: [
        {
          value: "scheduled",
          label: "Scheduled Medications",
          width: "180",
          icon: "fas fa-calendar"
        },
        {
          value: "prn",
          label: "Prn Medications",
          width: "180",
          icon: "fas fa-list-ul"
        }
      ],
      scheduledList: [],
      formScheduledId: null,
      formScheduled: {
        medication: null,
        route: null,
        dosage: "",
        measurementUnit: null,
        startDate: null,
        endDate: null,
        untilDischarge: false,
        frequencyId: null,
        daysIntervalId: null,
        weekDays: [],
        timesPerDayId: null,
        times: [],
        instructions: ""
      },
      formScheduledErrors: {
        medication: [],
        route: [],
        dosage: [],
        measurementUnit: [],
        startDate: [],
        endDate: [],
        frequencyId: [],
        daysIntervalId: [],
        weekDays: [],
        timesPerDayId: []
      },
      formPredefinedProtocol: {
        startDate: null,
        predefinedProtocol: null
      },
      formPredefinedProtocolErrors: {
        startDate: [],
        predefinedProtocol: []
      },
      scheduledListeners: {
        selectionChange: selectionEvent => {
          self.scheduledMedicationsSelected = selectionEvent.selection.map(
            s => s.data.id
          );
        }
      },
      prnMedicationsScheduledListeners: {
        selectionChange: selectionEvent => {
          self.prnMedicationsSelected = selectionEvent.selection.map(
            s => s.data.id
          );
        }
      },
      scheduledGridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true,
          checkbox: true,
          rowCheckboxSelection: true,
          showCheckAll: true
        }
      },
      scheduledMedicationsSelected: [],
      scheduledSubscribed: false,
      prnList: [],
      formPrnId: null,
      formPrn: {
        medication: null,
        route: null,
        dosage: "",
        measurementUnit: null,
        startDate: null,
        endDate: null,
        maximumDosage: "",
        instructions: ""
      },
      formPrnErrors: {
        medication: [],
        route: [],
        dosage: [],
        measurementUnit: [],
        startDate: [],
        endDate: []
      },
      prnMedicationsSelected: [],
      prnSubscribed: false,
      gridsRendered: 0,
      showReportRequestsModal: false
    };
  },
  mounted() {
    this.fetchScheduledMedications();
    this.fetchPrnMedications();
    this.fetchData();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showAlertError"]),
    ...mapActions("client", [
      "fetchMedicationRoutes",
      "fetchMeasurements",
      "fetchPredefinedProtocols"
    ]),
    tryHookDropdownButtons() {
      this.gridsRendered += 1;
      if (this.gridsRendered >= 4) this.hookDropdownButtons();
    },
    fetchData() {
      this.fetchMedicationRoutes();
      this.fetchMeasurements();
      this.fetchPredefinedProtocols();
    },
    async searchMedications(search, loading) {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      if (search && search.trim().length >= 3) {
        this.medications = [];
      }

      this.lastTimeout = setTimeout(async () => {
        loading(true);
        if (search.trim().length >= 3) {
          const medications = await medicationServer.query(
            {
              searchPhrase: search,
              page: 0,
              pageSize: 1000000,
              orderBy: "name"
            },
            { "Hide-Loading": true }
          );
          this.medications = medications.map(m => ({
            value: m.id,
            label: m.name
          }));
        } else {
          this.medications = [];
        }
        loading(false);
      }, 1000);
    },
    async fetchScheduledMedications() {
      const scheduledList = await scheduledMedicationServer.query(
        this.eocId,
        {}
      );

      this.scheduledList = scheduledList.map(m => ({
        ...m,
        startDate: this.formatDateTimeMysql(m.startDate),
        endDate: m.endDate ? this.formatDateTimeMysql(m.endDate) : null
      }));
    },
    clearErrors() {
      this.formScheduledErrors = {
        medication: [],
        route: [],
        dosage: [],
        measurementUnit: [],
        startDate: [],
        endDate: [],
        frequencyId: [],
        daysIntervalId: [],
        weekDays: [],
        timesPerDayId: []
      };
    },
    addScheduledMedication() {
      this.formScheduledId = null;
      this.formScheduled = {
        medication: null,
        route: null,
        dosage: "",
        measurementUnit: null,
        startDate: null,
        untilDischarge: false,
        endDate: null,
        frequencyId: null,
        daysIntervalId: null,
        weekDays: [],
        timesPerDayId: null,
        times: [],
        instructions: ""
      };
      this.clearErrors();
      this.$refs["form-scheduled-modal"].show();
    },
    validateScheduledSubmit() {
      let withoutErrors = true;

      this.formScheduledErrors.medication = [];
      if (!validateRequired(this.formScheduled.medication)) {
        this.formScheduledErrors.medication.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.route = [];
      if (!validateRequired(this.formScheduled.route)) {
        this.formScheduledErrors.route.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.dosage = [];
      if (!validateRequired(this.formScheduled.dosage)) {
        this.formScheduledErrors.dosage.push("This field is required");
        withoutErrors = false;
      } else if (!validateNumberNotNegative(this.formScheduled.dosage)) {
        this.formScheduledErrors.dosage.push(
          "Dosage cannot be a negative number!"
        );
        withoutErrors = false;
      }

      if (
        this.formScheduled.dosage &&
        !validateNumberLessEqualThan(this.formScheduled.dosage, 100000000)
      ) {
        this.formScheduledErrors.dosage.push("Maximum value of 100000000");
        withoutErrors = false;
      }

      this.formScheduledErrors.measurementUnit = [];
      if (!validateRequired(this.formScheduled.measurementUnit)) {
        this.formScheduledErrors.measurementUnit.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.startDate = [];
      if (!validateRequired(this.formScheduled.startDate)) {
        this.formScheduledErrors.startDate.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.endDate = [];
      if (
        !this.formScheduled.untilDischarge &&
        !validateRequired(this.formScheduled.endDate)
      ) {
        this.formScheduledErrors.endDate.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.frequencyId = [];
      if (!validateRequired(this.formScheduled.frequencyId)) {
        this.formScheduledErrors.frequencyId.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.weekDays = [];
      if (
        this.formScheduled.frequencyId == "daysOfWeek" &&
        this.formScheduled.weekDays.length == 0
      ) {
        this.formScheduledErrors.weekDays.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.daysIntervalId = [];
      if (
        this.formScheduled.frequencyId == "daysInterval" &&
        !validateRequired(this.formScheduled.daysIntervalId)
      ) {
        this.formScheduledErrors.daysIntervalId.push("This field is required");
        withoutErrors = false;
      }

      this.formScheduledErrors.timesPerDayId = [];
      if (!validateRequired(this.formScheduled.timesPerDayId)) {
        this.formScheduledErrors.timesPerDayId.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitScheduledMedication(modalEvent) {
      modalEvent.preventDefault();
      const result = await this.validateScheduledSubmit();
      if (result) {
        const data = {
          episodeOfCareId: this.eocId,
          medicationId: this.formScheduled.medication.value,
          dosageAmount: parseFloat(this.formScheduled.dosage),
          unitOfMeasurementId: this.formScheduled.measurementUnit.value,
          medicationRouteId: this.formScheduled.route.value,
          instructions: this.formScheduled.instructions,
          startDate: this.formatDateTimeSql(this.formScheduled.startDate),
          endDate: this.formScheduled.endDate
            ? this.formatDateTimeSql(this.formScheduled.endDate)
            : null,
          untilDischarge: this.formScheduled.untilDischarge,
          frequency:
            this.formScheduled.frequencyId.charAt(0).toUpperCase() +
            this.formScheduled.frequencyId.slice(1),
          interval: this.intervalAmounts.frequency,
          intervalAmount: this.intervalAmounts.amount,
          timesPerDay: Object.values(this.formScheduled.times).length,
          monday: this.formScheduled.weekDays.indexOf("1") >= 0,
          tuesday: this.formScheduled.weekDays.indexOf("2") >= 0,
          wednesday: this.formScheduled.weekDays.indexOf("3") >= 0,
          thursday: this.formScheduled.weekDays.indexOf("4") >= 0,
          friday: this.formScheduled.weekDays.indexOf("5") >= 0,
          saturday: this.formScheduled.weekDays.indexOf("6") >= 0,
          sunday: this.formScheduled.weekDays.indexOf("0") >= 0,
          times: Object.values(this.formScheduled.times)
        };
        let request = null;
        if (this.formScheduledId) {
          request = scheduledMedicationServer.update(
            this.formScheduledId,
            data
          );
        } else {
          request = scheduledMedicationServer.create(data);
        }
        request
          .then(() => {
            this.fetchScheduledMedications();
            this.$refs["form-scheduled-modal"].hide();
            this.showAlertSuccess();
          })
          .catch(e => {
            this.showAlertError({ message: e.response.data.errorCode });
          });
      }
    },
    addPredefinedProtocol() {
      this.formPredefinedProtocol = {
        startDate: null,
        predefinedProtocol: null
      };
      this.formPredefinedProtocolErrors = {
        startDate: [],
        predefinedProtocol: []
      };
      this.$refs["form-predefined-protocol-modal"].show();
    },
    validatePredefinedProtocolSubmit() {
      let withoutErrors = true;

      this.formPredefinedProtocolErrors.startDate = [];
      if (!validateRequired(this.formPredefinedProtocol.startDate)) {
        this.formPredefinedProtocolErrors.startDate.push(
          "This field is required"
        );
        withoutErrors = false;
      }

      this.formPredefinedProtocolErrors.predefinedProtocol = [];
      if (!validateRequired(this.formPredefinedProtocol.predefinedProtocol)) {
        this.formPredefinedProtocolErrors.predefinedProtocol.push(
          "This field is required"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitPredefinedProtocol(modalEvent) {
      modalEvent.preventDefault();
      const result = await this.validatePredefinedProtocolSubmit();
      if (result) {
        const data = {
          episodeOfCareId: this.eocId,
          startDate: this.formatDateTimeSql(
            this.formPredefinedProtocol.startDate
          ),
          protocolId: this.formPredefinedProtocol.predefinedProtocol.value
        };
        await predefinedProtocolServer.createFromProtocol(data);

        this.fetchScheduledMedications();
        this.fetchPrnMedications();
        this.$refs["form-predefined-protocol-modal"].hide();
        this.showAlertSuccess();
      }
    },
    initializeTimes() {
      if (!this.formScheduled.timesPerDayId) {
        this.formScheduled.times = [];
      } else {
        let newTimes = {};
        for (
          let index = 0;
          index <
          timesPerDayOptions[this.formScheduled.timesPerDayId].initialTimes
            .length;
          index++
        ) {
          const initialTime =
            timesPerDayOptions[this.formScheduled.timesPerDayId].initialTimes[
              index
            ];
          newTimes[index] = initialTime;
        }
        this.formScheduled.times = newTimes;
      }
    },
    setTime(timeIndex, newTime) {
      this.formScheduled.times[timeIndex] = newTime;
    },
    removeSelectedScheduledMedication() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete these records?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await scheduledMedicationServer.deleteMultiple(
            this.scheduledMedicationsSelected
          );
          this.fetchScheduledMedications();
          this.showAlertSuccess();
        })
        .catch(function() {});
    },
    removeSelectedPrnMedication() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete these records?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await prnMedicationServer.deleteMultiple(this.prnMedicationsSelected);
          this.fetchPrnMedications();
          this.showAlertSuccess();
        })
        .catch(function() {});
    },
    async fetchPrnMedications() {
      const prnList = await prnMedicationServer.query(this.eocId, {});

      this.prnList = prnList.map(m => ({
        ...m,
        startDate: m.startDate ? this.formatDateTimeMysql(m.startDate) : null,
        stopDate: m.stopDate ? this.formatDateTimeMysql(m.stopDate) : null
      }));
    },
    addPrnMedication() {
      this.formPrnId = null;
      this.formPrn = {
        medication: null,
        route: null,
        dosage: "",
        measurementUnit: null,
        startDate: null,
        endDate: null,
        maximumDosage: "",
        instructions: ""
      };
      this.formPrnErrors = {
        medication: [],
        route: [],
        dosage: [],
        measurementUnit: [],
        startDate: [],
        endDate: []
      };
      this.$refs["form-prn-modal"].show();
    },
    validatePrnSubmit() {
      let withoutErrors = true;

      this.formPrnErrors.medication = [];
      if (!validateRequired(this.formPrn.medication)) {
        this.formPrnErrors.medication.push("This field is required");
        withoutErrors = false;
      }

      this.formPrnErrors.route = [];
      if (!validateRequired(this.formPrn.route)) {
        this.formPrnErrors.route.push("This field is required");
        withoutErrors = false;
      }

      this.formPrnErrors.dosage = [];
      if (!validateRequired(this.formPrn.dosage)) {
        this.formPrnErrors.dosage.push("This field is required");
        withoutErrors = false;
      } else if (!validateNumberNotNegative(this.formPrn.dosage)) {
        this.formPrnErrors.dosage.push("Dosage cannot be a negative number!");
        withoutErrors = false;
      }

      if (
        this.formPrn.dosage &&
        !validateNumberLessEqualThan(this.formPrn.dosage, 100000000)
      ) {
        this.formPrnErrors.dosage.push("Maximum value of 100000000");
        withoutErrors = false;
      }

      this.formPrnErrors.measurementUnit = [];
      if (!validateRequired(this.formPrn.measurementUnit)) {
        this.formPrnErrors.measurementUnit.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitPrnMedication(modalEvent) {
      modalEvent.preventDefault();
      const result = await this.validatePrnSubmit();
      if (result) {
        const data = {
          episodeOfCareId: this.eocId,
          startDate: this.formPrn.startDate
            ? this.formatDateTimeSql(this.formPrn.startDate)
            : null,
          stopDate: this.formPrn.endDate
            ? this.formatDateTimeSql(this.formPrn.endDate)
            : null,
          maximumDosagePerDay: this.formPrn.maximumDosage,
          medicationId: this.formPrn.medication.value,
          dosageAmount: parseFloat(this.formPrn.dosage),
          unitOfMeasurementId: this.formPrn.measurementUnit.value,
          medicationRouteId: this.formPrn.route.value,
          instructions: this.formPrn.instructions
        };
        if (this.formPrnId) {
          await prnMedicationServer.update(this.formPrnId, data);
        } else {
          await prnMedicationServer.create(data);
        }

        this.fetchPrnMedications();
        this.$refs["form-prn-modal"].hide();
        this.showAlertSuccess();
      }
    },
    getDaysIntervalId(intervalLabel, intervalAmount) {
      switch (`${intervalAmount}${intervalLabel}`) {
        case "2Days":
          return "every2Days";
        case "3Days":
          return "every3Days";
        case "1Weeks":
          return "1timePerWeek";
        case "2Weeks":
          return "everyTwoWeeks";
        case "3Weeks":
          return "every3Weeks";
        case "28Days":
          return "every28Days";
        case "30Days":
          return "every30Days";

        default:
          return null;
      }
    },
    toggleTransferMedsToMars() {
      this.transferToMars = !this.transferToMars;
    }
  },
  computed: {
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ...mapState("client", {
      medicationRoutes: state =>
        state.medicationRoutes.map(medicationRoute => ({
          value: medicationRoute.id,
          label: medicationRoute.name
        })),
      measurements: state =>
        state.measurements.map(measurement => ({
          value: measurement.id,
          label: measurement.name
        })),
      predefinedProtocols: state =>
        state.predefinedProtocols.map(predefinedProtocol => ({
          value: predefinedProtocol.id,
          label: predefinedProtocol.name
        }))
    }),
    scheduledItems() {
      return this.scheduledList.map(item => {
        let rowHeight = 50;
        const singleLineHeight = 25;
        const charsMedicationPerLine = 40;
        const charsInstructionsPerLine = 80;
        const maxFactor = Math.max(
          Math.ceil(
            `${item.medication.name}, ${item.dosageAmount} ${item.unitOfMeasurement.name} by ${item.medicationRoute.name}`
              .length / charsMedicationPerLine
          ),
          Math.ceil(item.instructions.length / charsInstructionsPerLine)
        );
        if (maxFactor > 1) rowHeight += singleLineHeight * (maxFactor - 1);
        return {
          ...item,
          rowHeight: rowHeight,
          inputRows: maxFactor
        };
      });
    },
    scheduledColumns() {
      return [
        {
          text: "Date Range",
          field: "startDate",
          width: 170,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">${this.formatDate(
              data.record.data.startDate
            )} - ${
              data.record.data.untilDischarge
                ? "Until Discharge"
                : this.formatDate(data.record.data.endDate)
            }</div>`
        },
        {
          text: "Medication",
          field: "medication",
          width: 180,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">${data.record.data.medication.name}, ${data.record.data.dosageAmount} ${data.record.data.unitOfMeasurement.name} by ${data.record.data.medicationRoute.name}</div>`,
          sortable(a, b) {
            return a.medication.name.localeCompare(b.medication.name);
          }
        },
        {
          text: "Status",
          field: "status",
          width: 101,
          editor: false,
          type: "template",
          template: data => `<span class="badge badge-warning px-4 py-2 text-white badge-fixed-size ${
            data.record.data.status == "Active" ? "bg-success" : "bg-danger"
          }">
            ${data.record.data.status}
          </span>`
        },
        {
          text: "Times",
          field: "times",
          width: 80,
          editor: false,
          type: "template",
          template: ({ record }) =>
            `<div class="text-wrap">${record.data.times
              .map(time => this.formatTimeOnly(time, "HH:mm"))
              .join(", ")}</div>`,
          sortable: false
        },
        {
          text: "Frequency",
          field: "frequency",
          editor: false,
          type: "template",
          width: 150,
          template: ({ record }) => {
            switch (record.data.frequency) {
              case "EveryDay":
                return "Every Day";
              case "DaysInterval":
                return daysIntervals[
                  this.getDaysIntervalId(
                    record.data.interval,
                    record.data.intervalAmount
                  )
                ].label;
              case "DaysOfWeek":
                return `<div class="text-wrap">${[
                  ...(record.data.sunday ? ["Sunday"] : []),
                  ...(record.data.monday ? ["Monday"] : []),
                  ...(record.data.tuesday ? ["Tuesday"] : []),
                  ...(record.data.wednesday ? ["Wednesday"] : []),
                  ...(record.data.thursday ? ["Thursday"] : []),
                  ...(record.data.friday ? ["Friday"] : []),
                  ...(record.data.saturday ? ["Saturday"] : [])
                ].join(", ")}</div>`;
              default:
                return "";
            }
          },
          sortable: false
        },
        {
          text: "Instructions",
          field: "instructions",
          editor: false,
          type: "template",
          width: 400,
          template: ({ record }) =>
            `<div class="text-wrap">${
              record.instructions ? record.instructions : ""
            }</div>`,
          sortable: false
        },
        {
          text: "",
          type: "action",
          field: "action",
          cellCls: "pointer-cell",
          align: "right",
          width: 40,
          actions: [
            {
              tooltip: "More",
              renderer: ({ record }) => {
                return this.createDropdownButton({
                  items: [
                    {
                      content: "Edit",
                      callback: () => {
                        this.formScheduledId = record.data.id;
                        const times = {};
                        for (
                          let index = 0;
                          index < record.data.times.length;
                          index++
                        ) {
                          const time = record.data.times[index];
                          times[index] = time;
                        }
                        this.formScheduled = {
                          medication: record.data.medication
                            ? {
                                value: record.data.medication.id,
                                label: record.data.medication.name
                              }
                            : null,
                          route: record.data.medicationRoute
                            ? {
                                value: record.data.medicationRoute.id,
                                label: record.data.medicationRoute.name
                              }
                            : null,
                          dosage: record.data.dosageAmount,
                          measurementUnit: record.data.unitOfMeasurement
                            ? {
                                value: record.data.unitOfMeasurement.id,
                                label: record.data.unitOfMeasurement.name
                              }
                            : null,
                          startDate: record.data.startDate
                            ? formatDateTimeMysql(record.data.startDate)
                            : null,
                          untilDischarge: record.data.untilDischarge,
                          endDate: record.data.endDate
                            ? formatDateTimeMysql(record.data.endDate)
                            : null,
                          frequencyId:
                            record.data.frequency.charAt(0).toLowerCase() +
                            record.data.frequency.slice(1),
                          daysIntervalId: this.getDaysIntervalId(
                            record.data.interval,
                            record.data.intervalAmount
                          ),
                          weekDays: [
                            ...(record.data.sunday ? ["0"] : []),
                            ...(record.data.monday ? ["1"] : []),
                            ...(record.data.tuesday ? ["2"] : []),
                            ...(record.data.wednesday ? ["3"] : []),
                            ...(record.data.thursday ? ["4"] : []),
                            ...(record.data.friday ? ["5"] : []),
                            ...(record.data.saturday ? ["6"] : [])
                          ],
                          timesPerDayId: `${record.data.timesPerDay}Time${
                            record.data.timesPerDay > 1 ? "s" : ""
                          }PerDay`,
                          times: times,
                          instructions: record.data.instructions
                        };
                        this.clearErrors();
                        this.$refs["form-scheduled-modal"].show();
                      }
                    },
                    {
                      content: "Delete",
                      callback: () => {
                        this.$dialog
                          .confirm(
                            {
                              title:
                                "Are you sure you want to delete this record?"
                            },
                            {
                              view: "confirm-delete"
                            }
                          )
                          .then(async () => {
                            await scheduledMedicationServer.delete(record.id);
                            this.fetchScheduledMedications();
                            this.showAlertSuccess();
                          })
                          .catch(function() {});
                      }
                    }
                  ]
                });
              }
            }
          ]
        }
      ];
    },
    frequencyOptions() {
      return Object.values(frequencies).map(f => ({
        value: f.key,
        label: f.label
      }));
    },
    scheduledFrequency: {
      get() {
        return this.formScheduled.frequencyId
          ? this.frequencyOptions.find(
              frequency => frequency.value == this.formScheduled.frequencyId
            )
          : null;
      },
      set(newValue) {
        this.formScheduled.frequencyId = newValue ? newValue.value : null;
      }
    },
    daysIntervalOptions() {
      return Object.values(daysIntervals).map(d => ({
        value: d.key,
        label: d.label
      }));
    },
    daysInterval: {
      get() {
        return this.formScheduled.daysIntervalId
          ? this.daysIntervalOptions.find(
              daysInterval =>
                daysInterval.value == this.formScheduled.daysIntervalId
            )
          : null;
      },
      set(newValue) {
        this.formScheduled.daysIntervalId = newValue ? newValue.value : null;
      }
    },
    timesPerDayOptions() {
      return Object.values(timesPerDayOptions).map(t => ({
        value: t.key,
        label: t.label
      }));
    },
    timesPerDay: {
      get() {
        return this.formScheduled.timesPerDayId
          ? this.timesPerDayOptions.find(
              timesPerDay =>
                timesPerDay.value == this.formScheduled.timesPerDayId
            )
          : null;
      },
      set(newValue) {
        this.formScheduled.timesPerDayId = newValue ? newValue.value : null;
        this.initializeTimes();
      }
    },
    timeOptions() {
      return timeOptions.map(t => ({
        value: t,
        text: this.formatTimeOnly(t, "HH:mm")
      }));
    },
    intervalAmounts() {
      switch (this.formScheduled.daysIntervalId) {
        case "every2Days":
          return {
            frequency: "Days",
            amount: 2
          };
        case "every3Days":
          return {
            frequency: "Days",
            amount: 3
          };
        case "1timePerWeek":
          return {
            frequency: "Weeks",
            amount: 1
          };
        case "everyTwoWeeks":
          return {
            frequency: "Weeks",
            amount: 2
          };
        case "every3Weeks":
          return {
            frequency: "Weeks",
            amount: 3
          };
        case "every28Days":
          return {
            frequency: "Days",
            amount: 28
          };
        case "every30Days":
          return {
            frequency: "Days",
            amount: 30
          };

        default:
          return {
            frequency: "Days",
            amount: 1
          };
      }
    },
    prnItems() {
      return this.prnList.map(item => {
        let rowHeight = 50;
        const singleLineHeight = 25;
        const charsMedicationPerLine = 40;
        const charsInstructionsPerLine = 80;
        const maxFactor = Math.max(
          Math.ceil(item.medication.name.length / charsMedicationPerLine),
          Math.ceil(item.instructions.length / charsInstructionsPerLine)
        );
        if (maxFactor > 1) rowHeight += singleLineHeight * (maxFactor - 1);
        return {
          ...item,
          rowHeight: rowHeight,
          inputRows: maxFactor
        };
      });
    },
    prnColumns() {
      let columns = [
        {
          text: "Date Range",
          field: "startDate",
          width: 170,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">${this.formatDate(
              data.record.data.startDate
            )} - ${this.formatDate(data.record.data.stopDate)}</div>`
        },
        {
          text: "Medication",
          field: "medication",
          width: 180,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">${data.record.data.medication.name}</div>`,
          sortable(a, b) {
            return a.medication.name.localeCompare(b.medication.name);
          }
        },
        {
          text: "Status",
          field: "status",
          width: 101,
          editor: false,
          type: "template",
          template: data => `<span class="badge badge-warning px-4 py-2 text-white badge-fixed-size ${
            data.record.data.status == "Active" ? "bg-success" : "bg-danger"
          }">
            ${data.record.data.status}
          </span>`
        },
        {
          text: "Dosage",
          field: "dosage",
          width: 100,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">
            ${data.record.data.dosageAmount +
              " " +
              data.record.data.unitOfMeasurement.name}</div>`,
          sortable(a, b) {
            return (a.dosageAmount + "").localeCompare(b.dosageAmount + "");
          }
        },
        {
          text: "Route",
          field: "route",
          width: 150,
          editor: false,
          type: "template",
          template: data =>
            `<div class="text-wrap">${data.record.data.medicationRoute.name}</div>`,
          sortable(a, b) {
            return a.medicationRoute.name.localeCompare(b.medicationRoute.name);
          }
        },
        {
          text: "Instructions",
          field: "instructions",
          editor: false,
          type: "template",
          width: 400,
          template: ({ record }) =>
            `<div class="text-wrap">${
              record.instructions ? record.instructions : ""
            }</div>`,
          sortable: false
        },
        {
          text: "",
          type: "action",
          field: "action",
          cellCls: "pointer-cell",
          align: "right",
          width: 40,
          actions: [
            {
              tooltip: "More",
              renderer: ({ record }) => {
                return this.createDropdownButton({
                  items: [
                    {
                      content: "Edit",
                      callback: () => {
                        this.formPrnId = record.data.id;
                        this.formPrn = {
                          medication: record.data.medication
                            ? {
                                value: record.data.medication.id,
                                label: record.data.medication.name
                              }
                            : null,
                          route: record.data.medicationRoute
                            ? {
                                value: record.data.medicationRoute.id,
                                label: record.data.medicationRoute.name
                              }
                            : null,
                          dosage: record.data.dosageAmount,
                          measurementUnit: record.data.unitOfMeasurement
                            ? {
                                value: record.data.unitOfMeasurement.id,
                                label: record.data.unitOfMeasurement.name
                              }
                            : null,
                          startDate: record.data.startDate
                            ? formatDateTimeMysql(record.data.startDate)
                            : null,
                          endDate: record.data.stopDate
                            ? formatDateTimeMysql(record.data.stopDate)
                            : null,
                          maximumDosage: record.data.maximumDosagePerDay,
                          instructions: record.data.instructions
                        };
                        this.clearErrors();
                        this.$refs["form-prn-modal"].show();
                      }
                    },
                    {
                      content: "Delete",
                      callback: () => {
                        this.$dialog
                          .confirm(
                            {
                              title:
                                "Are you sure you want to delete this record?"
                            },
                            {
                              view: "confirm-delete"
                            }
                          )
                          .then(async () => {
                            await prnMedicationServer.delete(record.id);
                            this.fetchPrnMedications();
                            this.showAlertSuccess();
                          })
                          .catch(function() {});
                      }
                    }
                  ]
                });
              }
            }
          ]
        }
      ];
      return columns;
    },
    transferToMars: {
      get() {
        return this.transferToMarsValue;
      },
      set(newValue) {
        // this.transferToMarsValue = newValue;
        this.$emit("change-transfer-to-mars", newValue);
      }
    },
    exportFilter() {
      return {
        eocsIds: [this.eocId]
      };
    }
  },
  watch: {
    showing(newValue) {
      if (newValue) {
        this.fetchScheduledMedications();
        this.fetchPrnMedications();
        this.fetchData();
      }
    }
  }
};
</script>

<style scoped>
.times-container {
  height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
<style>
.medication-tabs a {
  color: white;
  padding: 5px;
  margin: 5px;
  border-radius: 5px;
}

.medication-tabs a.active {
  background-color: #01549b !important;
}

.medication-tabs a:hover {
  color: white;
  background-color: #54a1e9;
}

.scheduled-container .b-grid-container .b-container {
  max-height: calc(100vh - 436px) !important;
}
.scheduled-container .edit-scheduled-instructions-item {
  font-size: 14px;
}
.prn-container .edit-prn-instructions-item {
  font-size: 14px;
}
.prn-container .b-grid-container .b-container {
  max-height: calc(100vh - 436px) !important;
}
.eoc-medications-container .badge-fixed-size {
  min-width: 85px !important;
}

.b-check-cell {
  width: 3em !important;
  min-width: 3em !important;
}

.b-check-header {
  flex-basis: 3em !important;
  min-width: 3em !important;
}
</style>
